import {useState} from 'react';
import styles from '../CustomerTimeline.module.scss';
import Avatar from 'components/Avatar';
import useCurrentUser from 'hooks/useCurrentUser';
import {getFullName} from 'helpers/user';
import {SendHorizontalIcon} from '../icons';
import classNames from 'classnames';

function TimeLineInput({
  onSubmit,
  isLoading,
}: {
  onSubmit: (text: string) => Promise<void>;
  isLoading: boolean;
}) {
  const currentUser = useCurrentUser();
  const [value, setValue] = useState('');

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const onKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey && value.trim() !== '') {
      e.preventDefault();
      await onSubmit(value);
      setValue('');
    }
  };

  const onSend = async () => {
    if (isLoading) return;
    await onSubmit(value);
    setValue('');
  };
  return (
    <div className={styles.timelineInputContainer}>
      <Avatar
        name={getFullName(currentUser)}
        file={currentUser?.avatar}
        size="md"
      />
      <div className={styles.textareaContainer}>
        <textarea
          placeholder="Write a note"
          className={styles.textarea}
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
        />
        <div
          className={classNames(styles.sendIconContainer, {
            [styles.loading]: isLoading,
          })}
          onClick={onSend}
        >
          <SendHorizontalIcon />
        </div>
      </div>
    </div>
  );
}

export default TimeLineInput;
